<template>
  <wp-items-list
    content-type="kb-articles"
    content-type-singular="kb-article"
    content-name="Knowledge Base Articles"
    content-name-singular="Knowledge Base Article"
  />
</template>

<script>
import WpItemsList from '@/views/wp-item/wp-items-list/WpItemsList.vue'

export default {
  components: {
    WpItemsList,
  },
}
</script>

<style scoped>

</style>
